import { ReactNode } from 'react';

import CTA, { CTAProps } from './cta';

interface ContentProps {
  children: ReactNode;
  cta?: CTAProps;
}

export default function Content({ children, cta }: ContentProps) {
  return (
    <div className="hidden w-full max-w-[360px] flex-col justify-between rounded-r-lg border-l border-catskill-white bg-whisper lg:flex lg:min-w-[360px] lg:px-6 lg:py-6">
      <div className="space-y-4">{children}</div>
      {cta && (
        <div className="mt-6">
          <CTA {...cta} />
        </div>
      )}
    </div>
  );
}
